import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const notes = [['mx', 'Guadalajara, México', 'María González', 'MG', 'hace 5 minutos'], ['ar', 'Buenos Aires, Argentina', 'Jorge Ramírez', 'JR', 'hace 12 minutos'], ['co', 'Bogotá, Colombia', 'Claudia López', 'CL', 'hace 18 minutos'], ['pe', 'Lima, Perú', 'Valeria Torres', 'VT', 'hace 27 minutos']];
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(false);
  const [closed, setClosed] = useState(false);
  useEffect(() => {
    if (closed) return;
    const start = window.setTimeout(() => setShow(true), 3000);
    return () => clearTimeout(start);
  }, [closed]);
  useEffect(() => {
    if (!show || closed) return;
    const hide = window.setTimeout(() => {
      setShow(false);
      window.setTimeout(() => {
        setIndex(current => (current + 1) % notes.length);
        setShow(true);
      }, 900);
    }, 5000);
    return () => clearTimeout(hide);
  }, [show, closed]);
  if (closed) return null;
  const [flag, city, name, initials, time] = notes[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-1/2 z-50 w-full -translate-x-1/2 px-4" data-id="element-166">
      <AnimatePresence mode="wait" data-id="element-167">
        {show && <motion.div key={index} initial={{
        opacity: 0,
        y: 35,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20
      }} className="pointer-events-auto mx-auto flex max-w-sm items-center gap-3 rounded-xl border border-gold/30 bg-dark-card p-3.5 shadow-[0_4px_30px_rgba(212,175,55,.25)]" data-id="element-168">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gold-gradient text-sm font-bold text-black" data-id="element-169">
              {initials}
            </span>

            <div className="min-w-0 flex-1" data-id="element-170">
              <p className="mb-1 text-[11px] text-gray-400" data-id="element-171">
                <img className="mr-1 inline h-3 w-4" src={`https://flagcdn.com/w20/${flag}.png`} alt="" data-id="element-172" />
                {city}
              </p>
              <p className="text-[13px] leading-snug" data-id="element-173">
                <b data-id="element-174">{name}</b>{' '}
                <span className="text-gray-300" data-id="element-175">
                  compró el Mega Pack Historia 360
                </span>
              </p>
              <p className="mt-1 flex items-center gap-1 text-[10px] text-green-400" data-id="element-176">
                <span className="h-1.5 w-1.5 rounded-full bg-green-400" data-id="element-177" />
                <ShoppingBag size={10} data-id="element-178" />
                Compra verificada · {time}
              </p>
            </div>

            <button type="button" onClick={() => setClosed(true)} className="self-start text-gray-500 hover:text-white focus-visible:outline focus-visible:outline-gold" aria-label="Cerrar notificación" data-id="element-179">
              <X size={15} data-id="element-180" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}